import React, { useEffect,  useRef, useState } from "react";

import { Row, Col } from "react-bootstrap";
import ColourDropDownFIlter from "../../../../components/FilterBox/ColourFilter/ColourDropDownFIlter";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import { format } from "date-fns";

import { Button, Offcanvas } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import ColourTable from "../../../../components/Tables/ColourTable";
import {
  ColourFilter,
  ColourFilterTable,
  ColourFilterTableFun,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";
// import "./InwardAnalysisCalendar.css";
export const InwardAnalysis = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const { ColourfilterData, ColourFilterDataTable } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );

  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");

  const [showFilter, setShowFilter] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleShow = () => setShowFilter(true);
  const handleClose = () => setShowFilter(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const [filter, setFilter] = useState({
    bookName: [],
    partyName: [],
    itemName: [],
  });
  const [search, setSearch] = useState({
    bookName: "",
    partyName: "",
    itemName: "",
  });

  const isApiCalled = useRef(false);

  useEffect(() => {
    if (!startDate || !endDate) return;
    if (isApiCalled.current) return;

    isApiCalled.current = true;

    dispatch(ColourFilter());

    dispatch(
      ColourFilterTable({
        FirmIDs: Firm,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
      })
    );
  }, [startDate, endDate, Firm]);

  const bookNameList =
    ColourfilterData?.Inwardbook?.map((item) => ({
      label: item.TransactionName,
      value: item.TransactionTypeID,
    })) || [];

  const partNameList =
    ColourfilterData?.InwardAc?.map((item) => ({
      label: item.Acname,
      value: item.Acid,
    })) || [];

  const itemList =
    ColourfilterData?.Inwarditem?.map((item) => ({
      label: item.itemname,
      value: item.itemid,
    })) || [];

  const columns = [
    {
      label: "Sr.No.",
      key: "srNumber",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Inward No",
      key: "InwNo",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Bill Date",
      key: "BillDate",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },

    {
      label: "Party Name",
      key: "Acname",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Unit", key: "UnitName", align: "left" },

    { label: "Quantity", key: "Qty", align: "right" },
    { label: "Rate", key: "Rate", align: "right", format: "true" },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    {
      label: "Net Amount",
      key: "NetAmount",
      align: "right",
      format: "true",
    },

    { label: "Lst Pur. Date", key: "LstDate", align: "center" },
    {
      label: "Lst Pur. Rate",
      key: "LstRate",
      align: "right",
      format: "true",
    },
    { label: "Lst Pur. Qty", key: "LstQty", align: "right", format: "true" },

    { label: "Diff Rate", key: "DiffRate", align: "right", format: "true" },

    { label: "High Date", key: "mxDate", align: "center" },
    { label: "High Rate", key: "mxRate", align: "right", format: "true" },

    { label: "Low Date", key: "mnDate", align: "center" },
    { label: "Low Rate", key: "mnRate", align: "right", format: "true" },

    {
      label: "Average Rate",
      key: "AvgRate",
      align: "right",
      format: "true",
    },
    {
      label: "Currently Stock",
      key: "ClosingStk",
      align: "right",
      format: "true",
    },
    {
      label: "Average Qty Cons.",
      key: "AvQtyCons",
      align: "right",
      format: "true",
    },
    {
      label: "Days Of Stock",
      key: "DaysOfStock",
      align: "right",
      format: "true",
    },
  ];

  // ✅ 3 decimal places format function
  const formatNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return 0;
    return Number(num).toFixed(3);
  };

  const initialData = (ColourFilterDataTable?.Data || []).map(
    (row, index, arr) => ({
      srNumber: index + 1,
      InwNo: row.InwNo?.trim() || "",
      BillDate: row.BillDate
        ? format(new Date(row.BillDate), "dd-MM-yyyy")
        : "",
      Acname: row.Acname?.trim() || "",
      ItemName: row.ItemName?.trim() || "",
      UnitName: row.UnitName || "",
      Qty: row.Qty || 0,
      Rate: row.Rate || 0,
      Amount: row.Amount || 0,
      NetAmount: row.NetAmount || 0,
      LstDate: row.LstDate ? format(new Date(row.LstDate), "dd-MM-yyyy") : "",
      LstRate: row.LstRate || 0,
      LstQty: formatNumber(row.LstQty),
      DiffRate: row.DiffRate || 0,
      mxDate: row.mxDate ? format(new Date(row.mxDate), "dd-MM-yyyy") : "",
      mxRate: row.mxRate || 0,
      mnDate: row.mnDate ? format(new Date(row.mnDate), "dd-MM-yyyy") : "",
      mnRate: row.mnRate || 0,
      AvgRate: row.AvgRate || 0,
      ClosingStk: row.ClosingStk || 0,
      AvQtyCons: row.AvQtyCons || 0,
      DaysOfStock: row.DaysOfStock || 0,
    }),
  );
  const handlesubmit = () => {
    dispatch(ColourFilterTableFun());
    dispatch(
      ColourFilterTable({
        FirmIDs: Firm,
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),

        BookIDs: filter.bookName.join(","),
        AcIDs: filter.partyName.join(","),
        ItemIDs: filter.itemName.join(","),

        FieldList: "",
      }),
    );

    setShowFilter(false);

  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (!ColourFilterDataTable || ColourFilterDataTable === "no") {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      {/* <h2 style={{ fontWeight: "700" }}>Inward Analysis</h2> */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>

        
        <Offcanvas
          show={showFilter}
          onHide={handleClose}
          placement="start"
          style={{
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }} >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour7,
                    padding: "13px 20px",
                    borderRadius: "12px 12px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour12,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    {" "}
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    padding: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour3,
                    borderRadius: "0px 0px 12px 12px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                      borderRadius: "10px",
                      cursor: "pointer",
                      textAlign: "center",
                      color: isdark === "light" ? "#000" : "#fff",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
              <ColourFilterBox
                title="Book Name"
                items={bookNameList}
                search={search.bookName}
                setSearch={(val) =>
                  setSearch((prev) => ({
                    ...prev,
                    bookName: val,
                  }))
                }
                selectedItems={filter.bookName}
                toggleItem={(item) =>
                  setFilter((prev) => ({
                    ...prev,
                    bookName: prev.bookName.includes(item.value)
                      ? prev.bookName.filter((i) => i !== item.value)
                      : [...prev.bookName, item.value],
                  }))
                }
              />

              <ColourFilterBox
                title="Party Name"
                items={partNameList}
                search={search.partyName}
                setSearch={(val) =>
                  setSearch((prev) => ({
                    ...prev,
                    partyName: val,
                  }))
                }
                selectedItems={filter.partyName}
                toggleItem={(item) =>
                  setFilter((prev) => ({
                    ...prev,
                    partyName: prev.partyName.includes(item.value)
                      ? prev.partyName.filter((i) => i !== item.value)
                      : [...prev.partyName, item.value],
                  }))
                }
              />

              <ColourFilterBox
                title="Item Name"
                items={itemList}
                search={search.itemName}
                setSearch={(val) =>
                  setSearch((prev) => ({
                    ...prev,
                    itemName: val,
                  }))
                }
                selectedItems={filter.itemName}
                toggleItem={(item) =>
                  setFilter((prev) => ({
                    ...prev,
                    itemName: prev.itemName.includes(item.value)
                      ? prev.itemName.filter((i) => i !== item.value)
                      : [...prev.itemName, item.value],
                  }))
                }
              />

              <Button
                onClick={handlesubmit}
                style={{
                  padding: "12px",
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  color: "#FFF",
                  width: "100%",
                  borderRadius: "12px",
                  fontWeight: "700",
                  height: "45px",
                  border: "none",
                }}
              >
                Apply Filters
              </Button>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
      <div
        className="d-none d-lg-block"
        style={{
          backgroundColor:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour4,
          padding: "15px",
          borderRadius: "12px",
          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour8
            }`,
        }}
      >
        <Row className="align-items-end g-2">
          {/* DATE RANGE */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <div>
              <h3
                style={{
                  color: isdark === "light" ? iscolour?.Colour7 : "#fff",
                  fontWeight: "700",
                  fontSize: "13px",
                  marginBottom: "5px",
                }}
              >
                Date Range
              </h3>
            </div>
            <div>
              <div
                onClick={() => setShowDatePicker(true)}
                className="date"
                style={{
                  padding: " 12px 20px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  textAlign: "center",
                  border: `1px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8}`,
                  color: isdark === "light" ? iscolour?.Colour : "#fff",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd/MM/yyyy")} - ${format(dateRange[0].endDate, "dd/MM/yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </Col>

          {/* Book Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Book Name"
              data={bookNameList}
              selectedValue={search.bookName}
              setSelectedValue={(value) =>
                setSearch((prev) => ({ ...prev, bookName: value }))
              }
              selectedId={filter.bookName}
              setSelectedId={(value) =>
                setFilter((prev) => ({ ...prev, bookName: value }))
              }
              placeholder="Select Book Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Party Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Party Name"
              data={partNameList}
              selectedValue={search.partyName}
              setSelectedValue={(value) =>
                setSearch((prev) => ({ ...prev, partyName: value }))
              }
              selectedId={filter.partyName}
              setSelectedId={(value) =>
                setFilter((prev) => ({ ...prev, partyName: value }))
              }
              placeholder="Select Party Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Item Name */}
          <Col xs={12} sm={6} md={6} lg={6} xl={3}>
            <ColourDropDownFIlter
              label="Item Name"
              data={itemList}
              selectedValue={search.itemName}
              setSelectedValue={(value) =>
                setSearch((prev) => ({ ...prev, itemName: value }))
              }
              selectedId={filter.itemName}
              setSelectedId={(value) =>
                setFilter((prev) => ({ ...prev, itemName: value }))
              }
              placeholder="Select Item Name"
              isdark={isdark}
              iscolour={iscolour}
              iscolourDark={iscolourDark}
            />
          </Col>

          {/* Submit Button */}

          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mt-3 hover-scale-btn "  >
            <button
              onClick={handlesubmit}
              style={{
                padding: "12px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour7
                    : iscolourDark?.Colour7,
                color: "#fff",
                width: "100%",
                borderRadius: "12px",
                fontWeight: "700",
                height: "45px",
                border: "none",

              }}
            >
              Apply Filter
            </button>
          </Col>
        </Row>
      </div>
      <div
        style={{
          marginTop: "20px",
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "14px",
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color: "#fff",
            fontWeight: "600",
            fontSize: "18px",
            margin: 0,
            letterSpacing: "1px",
          }}
        >
          INWARD ANALYSIS
        </div>

        <ColourTable columns={columns} data={initialData} />
      </div>
      {/* 🔷 DATE PICKER MODAL */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "12px",
                padding: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "8px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
